import { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import AppToast from "../../../../shared/components/AppToast";
import useFormState from "../../../../shared/hooks/useFormState";
import { ensureCatalogAuth } from "../../../../services/backend/authService";
import { editarSucursal } from "../../../../services/backend/adminService";
import logger from "../../../../shared/utils/logger";

export const SucursalFormDialog = ({
  visible,
  mode = "agregar",
  sucursal,
  onCancel,
  onSave,
}) => {
  const isEdit = mode === "editar";
  const toastRef = useRef(null);
  const [saving, setSaving] = useState(false);

  const { values, errors, setField, reset, validate } = useFormState(
    { almacen: "", nombre: "", descripcion: "" },
    {
      nombre: [(v) => (!v?.trim() || v.trim().length < 2 ? "El nombre debe tener al menos 2 caracteres." : null)],
      descripcion: [(v) => (!v?.trim() ? "La descripción es obligatoria." : null)],
    }
  );

  useEffect(() => {
    if (!visible) return;
    if (isEdit && sucursal?.almacen) {
      reset({
        almacen: String(sucursal.almacen),
        nombre: String(sucursal.sucursal ?? sucursal.nombre ?? ""),
        descripcion: String(sucursal.descripcion ?? ""),
      });
    } else if (!isEdit) {
      reset({ almacen: "", nombre: "", descripcion: "" });
    }
  }, [visible, mode, sucursal, isEdit]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSave = async () => {
    if (!validate()) return;
    setSaving(true);
    try {
      await ensureCatalogAuth();
      await editarSucursal(values.almacen, values.descripcion.trim(), values.nombre.trim());
      reset({ almacen: "", nombre: "", descripcion: "" });
      onCancel();
      if (onSave) await onSave();
    } catch (err) {
      logger.error("Error al guardar sucursal:", err);
      toastRef.current?.show({ severity: "error", summary: "Error", detail: err.message || "Error al guardar sucursal", life: 4000 });
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    reset({ almacen: "", nombre: "", descripcion: "" });
    onCancel();
  };

  return (
    <Dialog
      header={isEdit ? "Editar Sucursal" : "Agregar Sucursal"}
      visible={visible}
      style={{ width: "56rem", maxWidth: "95vw" }}
      onHide={handleCancel}
    >
      <AppToast ref={toastRef} />
      <div className="pt-3">
        {isEdit && (
          <div className="formgrid grid align-items-center mb-4">
            <label htmlFor="almacen" className="col-12 md:col-3 text-xl">
              Almacén
            </label>
            <div className="col-12 md:col-9">
              <InputText
                id="almacen"
                value={values.almacen}
                disabled
                className="w-full"
              />
            </div>
          </div>
        )}
        <div className="formgrid grid align-items-center mb-4">
          <label htmlFor="descripcion" className="col-12 md:col-3 text-xl">
            Descripción
          </label>
          <div className="col-12 md:col-9">
            <InputText
              id="descripcion"
              value={values.descripcion}
              onChange={(e) => setField("descripcion", e.target.value)}
              className={`w-full ${errors.descripcion ? "p-invalid" : ""}`}
              disabled={saving}
            />
            {errors.descripcion && (
              <small className="p-error">{errors.descripcion}</small>
            )}
          </div>
        </div>
        <div className="formgrid grid align-items-center mb-4">
          <label htmlFor="nombre" className="col-12 md:col-3 text-xl">
            Nombre
          </label>
          <div className="col-12 md:col-9">
            <InputText
              id="nombre"
              value={values.nombre}
              onChange={(e) => setField("nombre", e.target.value)}
              className={`w-full ${errors.nombre ? "p-invalid" : ""}`}
              disabled={saving}
              autoFocus
            />
            {errors.nombre && (
              <small className="p-error">{errors.nombre}</small>
            )}
          </div>
        </div>

        <div className="flex justify-content-end gap-2">
          {isEdit ? (
            <>
              <Button
                className="p-button-text"
                label="cancelar"
                onClick={handleCancel}
                disabled={saving}
              />
              <Button
                className="p-button"
                label="grabar"
                onClick={handleSave}
                loading={saving}
                disabled={saving}
              />
              
            </>
          ) : (
            <Button
              className="p-button p-button-secondary"
              label="cancelar"
              onClick={handleCancel}
            />
          )}
        </div>
      </div>
    </Dialog>
  );
};
